module.exports = __webpack_public_path__ + "images/growth-inst4.png";